export default {
  url: process.env.VUE_APP_BASE_URL,
  jobs_url:
    process.env.VUE_APP_CAREER_PAGE_JOBS ||
    "https://www.careers-page.com/cowlar-design-studio/job",
  jobs_api_url:
    process.env.VUE_APP_CAREER_PAGE_JOBS ||
    "https://api.manatal.com/open/v3/career-page/cowlar-design-studio/jobs/?page_size=999999",
};
